import {
  Accordion as MuiAccordion,
  AccordionProps,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummaryProps,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetailsProps,
  styled,
} from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { type HealthxchangeThemeColours } from '../../theme/defaultTheme';
import { HXCIcon, Icons } from '../HXCIcon';

export const Accordion = ({
  fontSize = '1rem',
  borderColor = 'lightGray',
  showBorder = true,
  sx,
  ...props
}: AccordionProps & {
  fontSize?: string;
  borderColor?: keyof typeof HealthxchangeThemeColours;
  showBorder?: boolean;
}) => (
  <MuiAccordion
    disableGutters
    elevation={0}
    square
    {...props}
    sx={[
      (theme) => ({
        backgroundColor: 'initial',
        borderTop: showBorder ? `1px solid ${theme.palette.lightGray.main}` : 'none',
        fontSize: fontSize,
        fontWeight: 500,
        '&::before': {
          display: 'none',
        },
      }),
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  />
);

const getAccordionSummarySx = (sx: AccordionSummaryProps['sx']): SxProps<Theme> => [
  (theme) => ({ padding: 0, color: theme.palette.black.main, fontWeight: 500 }),
  ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
];

const DEFAULT_EXPAND_ICON = <HXCIcon name={Icons.DropdownSm} color={'black'} />;

type UiKitAccordionSummaryProps = AccordionSummaryProps & {
  showExpandIcon?: boolean;
};

export const AccordionSummary = styled(
  ({ sx, expandIcon, showExpandIcon = true, ...props }: UiKitAccordionSummaryProps) => (
    <MuiAccordionSummary
      {...props}
      expandIcon={showExpandIcon ? (expandIcon ?? DEFAULT_EXPAND_ICON) : null}
      sx={getAccordionSummarySx(sx)}
    />
  ),
)({
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)',
  },
});

export const AccordionDetails = styled((props: AccordionDetailsProps) => (
  <MuiAccordionDetails {...props} />
))({
  fontSize: '0.875rem',
});
